export enum AdminRequestsSections {
  Clients = 'customers',
  Assignments = 'assignments',
  Members = 'members',
  Workers = 'workers',
}
